module.exports = __webpack_public_path__ + "media/images/doctor-day/doctorday-template-az-205e382eae3f55493715dddd580b6acb.png";